import { useState, useEffect, useCallback } from 'react';
import RightSidebar from "./RightSidebar";
import BottomBar from "./BottomBar";
import StepTabs from "./StepTabs";
import "./TransactionDetail.css";
import { RiskAssesForm } from "./forms/risk-assesment/riskassessForm";
import{useValidateRiskAssessment} from "../validations/validationHooks/useValidationRiskAssessment";
import { utilityService } from "../requests/utilityService";
import config from './config';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { diligenceObservable } from '../observers/deligenceObservable';
import { AlreadyEnhancedPopup } from './popups/alreadyEnhancedPopup';
import { riskAssesContObservable } from '../observers/riskAssesContObservable';
import { RiskAssessmentFactory } from '../factory/riskAssessmentFactory';
import { useEntityId } from '../hooks/useEntityId';
import FloatingMessageCenter from "./FloatingMessageCenter";
import FloatingQueryCenter from "./FloatingQueryCenter";
import {EmailSuccess,EmailFailed,PageValidation,UndertakeElectronicPEP,MediaSearchConducted, InfluenceTransaction} from "../components/popups/allPopup";
import LoaderModal from './Loader';
import ConfirmationModal from "./ui/ConfirmationModal";
import ErrorModal from "./ui/ErrorModal";
import ContactModal from "./ui/ContactModal";
import { userSession } from '../observers/userObserver';
import { getPreviousEnabledSection } from '../utils/navigationHelper';
import { reloadAfterValidate } from '../utils/reloadAfterValidate';
import ViewModeBanner from "./ui/ViewModeBanner";


const RiskAsses = ({isReport}) => {
  const ownerId = "RiskAssesment";
  const [searchParams, setSearchParams] = useSearchParams();


  const navigate = useNavigate();
  const location = useLocation();
  const { requestId, transactionId, status, propertyId } = location.state || {};
  // const entityId = localStorage.sharedData.getItem("entityId") || searchParams.get("entityId") || location.state?.entityId;  
  // const entityId = localStorage.getItem("entityId") || searchParams.get("entityId") || location.state?.entityId;
   const entityId = useEntityId();

  console.log("Request ID:", requestId);
  console.log("Transaction ID:", transactionId);
  console.log("Status", status);
  console.log("Property", propertyId);
  console.log("entity", entityId);
   const [isReadOnly, setIsReadOnly] = useState(
     searchParams.get("readonly") === "true" ||
     searchParams.get("view") === "true"
   );
  const [adverseSearch, setAdverseSearch] = useState(""); // Specific to this question
  const {errors, validateRiskAssesmemnt} = useValidateRiskAssessment();
    const [isRiskAssesmentCompleted, setIsRiskAssesmentCompleted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isValidated, setIsValidated] = useState(false);
 
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [Modallabel, setModalLabel] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  
  const [showTextArea, setShowTextArea] = useState(false); // For text areas
  const [showDropdown, setShowDropdown] = useState(false); // For dropdown visibility
  const [isTextareaVisible, setIsTextareaVisible] = useState(false);
  const [showTextarea, setShowTextarea] = useState(false);
 
const [modalOpen, setModalOpen] = useState(false);
const [modalHeading, setModalHeading] = useState("");
const showLoader = (message) => {
  setLoadingMessage(message);
  setIsLoading(true);
};

const hideLoader = () => {
  setIsLoading(false);
  setLoadingMessage('');
};
  const [isLoading, setIsLoading] = useState(false);
const [loadingMessage, setLoadingMessage] = useState('');

  const checkIsReadOnly = (status = undefined) => {
    const isEditMode = searchParams.get("edit") === "true";
    const isTransactionCompleted = status === "Validated";
    const isReadOnlyFromURL = searchParams.get("readonly") === "true";
    const isViewMode = searchParams.get("view") === "true";

    setIsRiskAssesmentCompleted(isTransactionCompleted)
    return isTransactionCompleted || isReadOnlyFromURL || isViewMode;
  };

  const fetchRiskAssessment = async (entityId) => {
    try {
      const token = userSession.getToken();
      console.log("🔄 Fetching risk assessment for Entity ID:", entityId);
  
      const response = await fetch(`${config["backend-url"]}/get_risk_assessment`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ entityId })  // ✅ entityId sent in request body
      });
  
      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || "Failed to fetch risk assessment");
      }
  
      const riskData = await response.json();
  
      // ✅ Store in localStorage
      localStorage.setItem("riskFormData", JSON.stringify(riskData));
      console.log("✅ Risk assessment data saved to localStorage:", riskData);
      setFormData(prev => ({
        ...prev,
        ...riskData  // overwrite matching fields
      }));
  
  
      return riskData;
  
    } catch (error) {
      console.error("❌ Error fetching risk assessment:", error.message);
    }
  };
  

  const clientFormData = localStorage.getItem("clientFormData");
  const companyName = clientFormData ? JSON.parse(clientFormData).companyName : "";


  const runSpecialCasesAfterSave = () => {
    const checkConditionsFor = [
      'pepOwner', 
      'sanctionedPerson', 
      'understandClientBussiness', 
      'particularTransaction', 
      'pepEvasive', 
      'transactionCompletedWithUndueSpeed', 
      'adversePublicity', 
      'adverseInformation', 
      'criminalProceedings', 
      'taxInvasionIndication', 
      'sectorFromDropdown'
    ];
  
    for (const condition of checkConditionsFor) {
      const value = formData[condition];
      handleSpecialCase(condition, value);
    }
  };


  useEffect(() => {
    const clientFormData = localStorage.getItem("clientFormData");
    const companyName = clientFormData ? JSON.parse(clientFormData).companyName : "";
    console.log("Company Name:", companyName);
  
    const fetchAndLoadRiskData = async () => {
      try {
        if (!entityId) {
          console.warn("Entity ID is missing!");
          return;
        }
  
        const data = await fetchRiskAssessment(entityId); // ✅ fetch from API
  
        if (data) {
          setFormData(data); // ✅ Set formData from API response directly
          setAdverseSearch(data.MediaSearchConducted || '');
          const isReadOnly = checkIsReadOnly(data.status);
          setIsReadOnly(isReadOnly);
          localStorage.setItem("riskFormData", JSON.stringify(data));

          const checkConditionsFor = [
              'pepOwner', 
              'sanctionedPerson', 
              'understandClientBussiness', 
              'particularTransaction', 
              'pepEvasive', 
              'transactionCompletedWithUndueSpeed', 
              'adversePublicity', 
              'adverseInformation', 
              'criminalProceedings', 
              'taxInvasionIndication', 
              'sectorFromDropdown'
            ];

          for (const condition of checkConditionsFor) {
            const value = data[condition];
            handleSpecialCase(condition, value);
          }

        } else {
          // ✅ fallback: load existing data from localStorage
          const localData = localStorage.getItem("riskFormData");
          if (localData) {
            setFormData(JSON.parse(localData));
            console.log("✅ Loaded fallback data from localStorage.");
          }
        }
      } catch (err) {
        console.error("Error in fetchAndLoadRiskData:", err);
      }
    };
  
    fetchAndLoadRiskData();
    setHasUnsavedChanges(false);
  }, [entityId]); // ✅ dependency ensures re-run if entityId changes
  



 


  const [formData, setFormData] = useState(()=>{
    // "RiskFormData" (capital R) is not a key anything writes, so this never hydrated
    // and the page rendered unlocked until the fetch returned. Every other page seeds
    // from its own cache the same way.
    const savedFormData = localStorage.getItem("riskFormData");
    return savedFormData ? JSON.parse(savedFormData) : RiskAssessmentFactory({});
  });

  // Single source of truth for the lock: the status on screen. Reading the
  // localStorage copy left a validated page rendering unlocked until a reload.
  const checkStatus = formData.status === "Validated";

  useEffect(() => {
    const isReadOnlyFromURL = searchParams.get("readonly") === "true";
    const isViewMode = searchParams.get("view") === "true";
    setIsReadOnly(isReadOnlyFromURL || isViewMode || checkStatus);
  }, [checkStatus, searchParams]);










  useEffect(()=>{
    if (formData.cashIntensive === "Yes"){
      diligenceObservable.setValue("Enhanced", "RiskAssesment cashInsensitive");
    } else if (formData.cashIntensive === "No"){
      diligenceObservable.remove("RiskAssesment cashInsensitive");
  }}, [formData.cashIntensive])

  // ✅ Handle dropdown or input changes
  // const handleChange = (e, index = null, field = null) => {
  //   setHasUnsavedChanges(true);
  const [showValueTextarea, setShowValueTextarea] = useState(false);
  const [showSecrecyTextarea, setShowSecrecyTextarea] = useState(false);
  const [showReimbursedTextarea, setShowReimbursedTextarea] = useState(false);
  useEffect(() => {
    setIsTextareaVisible(formData.DoubtDocumentAccuracy === "Yes");

    setshowevidenceTextarea(formData.NegativeNewsFound === "Yes");
    setShowTextarea(formData.TransactionCompletedWithUndueSpeed === "Yes");
    setShowValueTextarea(formData.TransactionBelowMarketValue === "Yes");
    setShowSecrecyTextarea(formData.UnreasonableLevelOfSecreacy === "Yes");
    setShowReimbursedTextarea(formData.MadeRepeatedFunsTransfer === "Yes");
  
  }, [
    formData.NegativeNewsFound,
    formData.DoubtDocumentAccuracy,
    formData.TransactionCompletedWithUndueSpeed,
    formData.TransactionBelowMarketValue,
    formData.UnreasonableLevelOfSecreacy,
    formData.MadeRepeatedFunsTransfer,
  ]);




  
  const updateRequestPendingAction = useCallback(async (requestId) => {
    const payload = {
      requestId: requestId,
      action: "Yes",
    };
  
    try {
      const token = userSession.getToken();
      const response = await fetch(`${config["backend-url"]}/updateRequestPendingAction`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json" // ✅ Required for JSON body
        },
        body: JSON.stringify(payload) // ✅ Send the actual payload
      });
  
      const data = await response.json();
  
      if (response.ok) {
        console.log("Update successful:", data);
       
      } else {
        console.error("Failed to update pending action:", data);
      }
    } catch (error) {
      console.error("Error during updateRequestPendingAction:", error);
    }
  }, []);




   const sendMail = async (userType) => {
    showLoader('Sending email, please wait...');
    try {
      console.log("Sending email to:", Modallabel);
      const payload = {
        requestId: requestId,
        userType: userType,
        Modallabel,
        Page: "Risk Assessment"  };
      
  
      const data = await utilityService.sendMail(payload); // await is optional if you don't need response


      console.log("✅ Email sent", data);

      if (userType === "MLNO"){
        await updateRequestPendingAction(requestId);
      }

      // setModalMessage(<EmailSuccess />)
      setModalMessage(<EmailSuccess />)
      // setIsEmailModalOpen(true)
      setModalOpen(true);
      setIsModalOpen(false);
          } catch (error) {
      console.error("❌ Failed to send email:", error);
      setModalMessage(<EmailFailed />)
      // setIsEmailModalOpen(false)
      setModalOpen(true);
   
    }
    hideLoader();
  };



const [isErrorModalOpen, setIsErrorModalOpen]= useState(false);
  const [searchErrorModalOpen, setSearchErrorModalOpen] = useState(false);
  const [searchErrorMessage, setSearchErrorMessage] = useState("");
  // ✅ Load data from localStorage on component mount

  // TODO: Complete this
  const handleSpecialCase = (name, value) => {

    console.log("Special case:", name, value);

    const conditions = {
      pepOwner: "Yes",
      sanctionedPerson: "Yes",
      understandClientBussiness: "No",
      particularTransaction: "No",
      pepEvasive: "Yes",
      transactionCompletedWithUndueSpeed: "Yes",
      adversePublicity: "Yes",
      adverseInformation: "Yes",
      criminalProceedings: "Yes",
      taxInvasionIndication: "Yes",
      sectorFromDropdown: "notNone" 
    };
  
    if (name in conditions) {
      const expected = conditions[name];
      const shouldContinue = expected === "notNone"
  ? value && value !== "None of the above"
  : value === expected;
      console.log("Special Case, Condition met:", name, value, expected, shouldContinue);
      if (shouldContinue) {
        riskAssesContObservable.setContinue(name);
      } else {
        riskAssesContObservable.remove(name);
      }
    }
  };
  
 
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
  
    const updatedValue = type === "checkbox" ? checked : value;
    const label = fieldLabelMap[name];
    setHasUnsavedChanges(true);
    setFormData((prev) => {
      const updatedFormData = {
        ...prev,
        [name]: updatedValue || "",
      };
  
      localStorage.setItem("riskFormData", JSON.stringify(updatedFormData));
  
      // ✅ Run modal logic based on the field being changed
      switch (name) {
        case "pep":
          if (updatedValue === "No") {
            setModalMessage(<UndertakeElectronicPEP />)
            setIsErrorModalOpen(true);
          }
          break;
  
        case "adverseSearch":
          if (updatedValue === "No") {
            setModalMessage(<MediaSearchConducted />)
            setIsErrorModalOpen(true);
          }
          break;

          case "InfluenceTransaction":
            if (updatedValue === "Yes"){
              setModalMessage(<InfluenceTransaction />)
            setIsErrorModalOpen(true);
            }
            break;
        case "TerroristFinancing":
          if (updatedValue === "Yes") {
            setModalLabel(label);
            setIsModalOpen(true);
          }
          break;
  
        case "FinancialCrime":
          if (updatedValue === "Yes") {
            setModalLabel(label);
            setIsModalOpen(true);
          }
          break;
  
        default:
          break;
      }
  
      return updatedFormData;
    });
  
  };
  
  




  const fieldLabelMap = {
    pep: 'Have you undertaken PEP & Sanctions screenings on the entity and its +25% UBOs?',
    adverseSearch: 'Have any adverse media searches been conducted?',
    TerroristFinancing: 'Is there a risk of Terrorist Financing?',
    FinancialCrime: 'Have you found any evidence of regulatory sanction or enforcement in relation to financial crime?',
    sectorFromDropdown: 'Does your client/counterparty belong to any of the following sectors?',
    cashIntensive: 'Is the client involved in a business which is cash intensive?',
  };

  
  const handleValidate = async () => {
    console.log("Validate clicked");
  
    // Validate what is actually on screen. The localStorage copy lags behind the
    // form (handleChangewithPopUp never writes it), so validating that snapshot
    // reported filled-in fields as missing.
    const updatedFormData = { ...formData };
    const errors = validateRiskAssesmemnt(updatedFormData);
    console.log("Validation Errors: ", errors);
  
    if (errors) {
      setModalMessage(
        <>
          <h2 style={{ margin: "10px 0", textAlign: "center" }}>
            Validation Result
          </h2>
          <strong>Please fill in the following required fields:</strong>
          <br />
          <div style={{ maxHeight: "200px", overflow: "auto" }}>
            {Object.keys(errors).map((field) => (
              <div key={field}>
                <ul>
                  {errors[field].map((error, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </>
      );
      setModalOpen(true);
      return;

    }
    setIsValidated(true);

     // ✅ Set this flag to indicate validation passed
  
    // ✅ No need to setFormData here — let saveRiskAssessment handle it
    console.log("✅ Validation passed. Saving as Validated...");
    await saveRiskAssessment(true);
  };





  const saveRiskAssessment = useCallback(async (validateNow = undefined) => {
    console.log("save initialized");
  
    const currentStatus = formData.status;
    const alreadyValidated = currentStatus === "Validated" || isValidated;
    setHasUnsavedChanges(false);
  
    console.log("Current Status:", currentStatus);
    console.log("Already Validated:", alreadyValidated);
    console.log("validateNow param:", validateNow);
  
    // ✅ Show modal and skip save if already validated and not a new validation attempt
    if (alreadyValidated && !validateNow) {
      setModalMessage("Saving Risk Assessment skipped. Already Validated.");
      setModalOpen(true);
      return;
    }
  
    // ✅ If trying to validate again, block it
    if (alreadyValidated && validateNow === true) {
      setModalMessage(<PageValidation page={"Risk Assessment"} />);
      setModalOpen(true);
      return;
    }
  
    // ✅ Determine final status
    const newStatus =
      alreadyValidated
        ? "Validated"
        : validateNow === true
        ? "Validated"
        : validateNow === false
        ? "Not Validated"
        : currentStatus;
  
    setLoading(true);
  
    try {
      const payload = {
        ...formData,
        entityId,
        status: newStatus,
        riskcontinuedflag:riskAssesContObservable.isContinue()
      };
  
      const response = await fetch(`${config["backend-url"]}/save_risk_assessment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${userSession.getToken()}`, // ✅ Use token from userSession
        },
        body: JSON.stringify(payload),
      });
  
      if (response.ok) {
        const successMessage =
          newStatus === "Validated"
            ? "Risk Assessment validated successfully!"
            : "Risk Assessment saved successfully!";
        setModalMessage(successMessage);
        runSpecialCasesAfterSave();
  
        setFormData((prev) => ({
          ...prev,
          status: newStatus,
        }));
  
        if (newStatus === "Validated") {
          setIsValidated(true);
          reloadAfterValidate();
        }

      } else {
        const error = await response.json();
        setModalMessage(error.error || "Failed to save data. Please try again.");
      }
    } catch (error) {
      console.error("❌ Error saving data:", error);
      setModalMessage("Error saving data. Please try again.");
    } finally {
      setModalOpen(true);
      setLoading(false);
      setIsReadOnly(checkIsReadOnly(newStatus));
    }
  }, [checkIsReadOnly, entityId, formData, isValidated]);
  
  
  const handleNext = useCallback(async () => {
    await saveRiskAssessment();
    const qs = searchParams.toString();
    if (riskAssesContObservable.isContinue()) {
      navigate(`/RiskAssesContinue?${qs}`, {
        state: {
          showSections: riskAssesContObservable.getContinueKeys(), // ✅ use the helper
          formData
        }
      });
    } else if (diligenceObservable.isEnhanced()) {
      navigate(`/Edd?${qs}`);
    } else {
      navigate(`/FinalReview?${qs}`);
    }
  }, [navigate, saveRiskAssessment, searchParams, formData]);

  const handleBack = useCallback(() => {
    // Check Client/Counterparty completion status
    const clientFormData = localStorage.getItem("clientFormData");
    let isClientCounterpartyCompleted = false;
    if (clientFormData) {
      const parsedData = JSON.parse(clientFormData);
      isClientCounterpartyCompleted = parsedData.entityStatus === "Validated" || parsedData.status === "Validated";
    }

    // Use navigation helper to determine previous enabled section
    const previousPath = getPreviousEnabledSection('/RiskAsses', {
      isEntityIdMissing: !entityId,
      isClientCounterpartyCompleted,
      searchParams
    });

    navigate(previousPath);
  }, [entityId, navigate, searchParams]);




  const [isPEP, setIsPEP] = useState(false);
  const [isUKPEP, setIsUKPEP] = useState(false);
 

  useEffect(() => {
    const savedData = localStorage.getItem("riskFormData");
  
    if (savedData) {
      const parsedData = JSON.parse(savedData);
      setFormData(parsedData);
      console.log("✅ Loaded riskFormData from localStorage:", parsedData);
  
      // Conditional visibility handlers
      setIsPEP(parsedData.pep === "Yes");
      setIsUKPEP(parsedData.ukPep === "Yes");
      setIsTextareaVisible(parsedData.DoubtDocumentAccuracy === "Yes");
      setShowTextarea(parsedData.TransactionCompletedWithUndueSpeed === "Yes");
      setShowValueTextarea(parsedData.TransactionBelowMarketValue === "Yes");
      setShowSecrecyTextarea(parsedData.UnreasonableLevelOfSecreacy === "Yes");
      setShowReimbursedTextarea(parsedData.MadeRepeatedFunsTransfer === "Yes");
      setshowevidenceTextarea(parsedData.TaxInvasionIndication === "Yes");
      setshowTaxEvasionTextarea(parsedData.TaxInvasionIndication === "Yes");
  
      // Optional: If using additional flags like showTextArea or showDropdown:
      if (parsedData.outstandingConcern === "Yes") setShowTextArea(true);
      if (parsedData.UBOIdentified === "Yes") setShowDropdown(true);
    }
  }, []);
  

  const handleChangewithPopUp = (e) => {
    const { name, value } = e.target;
  
    setFormData((prev) => {
      const updatedFormData = { ...prev, [name]: value };
      // The report still reads this copy, so it has to move with the form.
      localStorage.setItem("riskFormData", JSON.stringify(updatedFormData));
      return updatedFormData;
    });
  
    if (
      (name === "terroristFinancing" || name === "financialCrime") &&
      value === "Yes"
    ) {
      if (name === "terroristFinancing") {
        setModalLabel("Evidence found related to terrorist financing.");
      } else if (name === "financialCrime") {
        setModalLabel("Evidence found related to financial crime.");
      }
      setIsModalOpen(true);
    }
  };
  
  
  const [showevidenceTextarea, setshowevidenceTextarea] = useState(false);
 
  const [showTaxEvasionTextarea, setshowTaxEvasionTextarea] = useState(false);
  
  const handleUpdate = () => {
    console.log("Save clicked");
    setHasUnsavedChanges(false);
  };

    
    
    const handleSearch = async (additionalInfo = "") => {
  const clientFormData = JSON.parse(localStorage.getItem("clientFormData") || "{}");

  const entityname = clientFormData.companyName || "";
  const country = clientFormData.countryOfIncorporation || "";
  const companyType = clientFormData.companyType || "LTD";
  const dateRange = 10;

  console.log("Entity Name:", entityname);

  if (!entityname || !country || !companyType) {
    setSearchErrorMessage("Missing required data. Please ensure company name, country of incorporation, and company type are filled in.");
    setSearchErrorModalOpen(true);
    return false;
  }

  const payload = {
    name: entityname,
    country: country,
    entityType: companyType,
    dateRange: dateRange,
    additionalInfo: additionalInfo,
  };

  try {
    const response = await fetch(`${config["backend-url"]}/make_media_search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userSession.getToken()}`,
      },
      body: JSON.stringify(payload),
    });

    console.log("Adverse media search triggered. Status:", response.status);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error("Adverse media search failed:", errorData);
      setSearchErrorMessage(`Failed to perform adverse media search: ${errorData.message || response.statusText}`);
      setSearchErrorModalOpen(true);
      return false;
    }

    return true;

  } catch (error) {
    console.error("Error calling adverse media search API:", error);
    setSearchErrorMessage("Failed to perform adverse media search. Please check your connection and try again.");
    setSearchErrorModalOpen(true);
    return false;
  }
};

const handleUboSearch = async (additionalInfo = "") => {
  const clientFormData = JSON.parse(localStorage.getItem("clientFormData") || "{}");
  const ubosData = JSON.parse(localStorage.getItem("corporateFormData") || "[]");
  const ubos = ubosData.ubos || [];
  const managers = JSON.parse(localStorage.getItem("managers") || "[]");

  const entityName = clientFormData.companyName || "";
  const name = clientFormData.companyName || "";
  const country = clientFormData.countryOfIncorporation || "";
  const companyType = clientFormData.companyType || "LTD";
  const dateRange = 10;

  console.log("UBO Search - Entity Name:", entityName);
  console.log("UBO Search - UBOs:", ubos);
  console.log("UBO Search - Managers:", managers);

  if (!entityName || !country || !companyType) {
    setSearchErrorMessage("Missing required data. Please ensure company name, country of incorporation, and company type are filled in.");
    setSearchErrorModalOpen(true);
    return false;
  }

  const payload = {
    entityName: entityName,
    name: name,
    country: country,
    entityType: companyType,
    dateRange: dateRange,
    additionalInfo: additionalInfo,
    ubos: ubos,
    managers: managers
  };

  try {
    const response = await fetch(`${config["backend-url"]}/ubo_adverseMedia`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userSession.getToken()}`,
      },
      body: JSON.stringify(payload),
    });

    console.log("UBO adverse media search triggered. Status:", response.status);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error("UBO adverse media search failed:", errorData);
      setSearchErrorMessage(`Failed to perform adverse media search: ${errorData.message || response.statusText}`);
      setSearchErrorModalOpen(true);
      return false;
    }

    return true;

  } catch (error) {
    console.error("Error calling UBO adverse media search API:", error);
    setSearchErrorMessage("Failed to perform adverse media search. Please check your connection and try again.");
    setSearchErrorModalOpen(true);
    return false;
  }
};

  useEffect(() => {
    setIsPEP(formData.pep === "Yes");
    setIsUKPEP(formData.ukPep === "Yes");
  }, [formData.pep, formData.ukPep]); // ✅ Include both in dependency array



 useEffect(() => {
  
      // ✅ Restore textarea visibility if saved value is "Yes"
      if (formData.DoubtDocumentAccuracy === "Yes") {
        setShowTextarea(true);
      }
    
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    // Your logic here
  };


  return (
    <>
      

      <div className={!isReport ? "transaction-detail" : ""}>
        {/* Main Form */}
        {!isReport && <StepTabs hasUnsavedChanges={hasUnsavedChanges} searchParams={searchParams} />}
        <ViewModeBanner
          isReadOnly={isReadOnly}
          status={formData?.status}
        />
        <div className="form-section">
        <RiskAssesForm

        handleSearch={handleSearch}
        handleUboSearch={handleUboSearch}

        isReport={isReport}
        formData={formData}
        handleChange={handleChange}
        companyName={companyName}
        isReadOnly={isReadOnly}
        handleSubmit={handleSubmit}
        handleChangewithPopUp={handleChangewithPopUp}
         />
{/* Right Sidebar */}
      {!isReport && <RightSidebar
      isPEP={formData.pep}  
      InfluenceTransaction={formData.InfluenceTransaction}
      IntermediaryName = {formData.IntermediaryName}
      />}
</div>

      </div>




      {!isReport && <BottomBar
        buttons={[
          { label: "Save", onClick: () => { saveRiskAssessment(false) },skipConfirmation: true , disabled: checkStatus },
          { label: "Validate & Lock", onClick: handleValidate , disabled: checkStatus },
           {
      label: "Back",
      onClick: handleBack,
      style: {},
      title: "Go back",
      disabled: false,
    },
          { label: "Next", onClick: handleNext }
        ]}
      />}
      <LoaderModal isOpen={isLoading} message={loadingMessage} />
    
          <ContactModal
  isModalOpen={isModalOpen}
  sendMail={sendMail}
  onClose={() => setIsModalOpen(false)}
/>
      
      <ErrorModal
        isOpen={isErrorModalOpen}
        message={modalMessage}
        onClose={() => setIsErrorModalOpen(false)}
      />

      <ErrorModal
        isOpen={searchErrorModalOpen}
        message={searchErrorMessage}
        onClose={() => setSearchErrorModalOpen(false)}
      />

       <ConfirmationModal
              isOpen={modalOpen}
              heading= {modalHeading}
              message={modalMessage}
              onClose={() => setModalOpen(false)}
            />
      <FloatingQueryCenter />
    </>
  );
};


export default RiskAsses;
